import type { FC } from "react";

import Carousel from "@/design-system/carousel";
import TelemetryButton from "@/design-system/telemetry-button";
import { useViewportInfoContext } from "@/src/contexts";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing } from "../../../styles/tokens.stylex";
import type { ILayerTile } from "../../common/LayerTile";
import LayerTile from "../../common/LayerTile";

export interface IBlogSection {
    initialData?: ILayerTile[];
}

const BlogSection: FC<IBlogSection> = ({ initialData }) => {
    const { isMobile } = useViewportInfoContext();

    const renderLaterTileList = (list: ILayerTile[]) => {
        return list.map((post, i) => (
            <LayerTile
                key={i}
                {...post}
                infoLabel={{
                    iconType: "Blog",
                    labelType: "blue",
                    text: "Blog goodie",
                    svgProps: { width: 10 },
                }}
                telemetryCustom={{
                    eventName: "homepg-LatestArtClick",
                    param1: `${post.id}`,
                    param2: `${i + 1}`,
                }}
            />
        ));
    };

    const latestPostsList = initialData ? renderLaterTileList(initialData) : [];

    return (
        <div {...stylex.props(styles.blogSection)}>
            <div {...stylex.props(styles.latestBlogs)}>
                {isMobile ? (
                    <Carousel centerMode={true} showArrows={false} itemsToShow={1.3}>
                        {latestPostsList}
                    </Carousel>
                ) : (
                    latestPostsList
                )}
            </div>
            <TelemetryButton
                as="a"
                variant="magentaRound"
                href="/blog"
                size="M"
                eventName="homepg-LatestContentMore"
                isExternal
                styleX={styles.blogLink}
            >
                Zobacz wszystkie artykuły
            </TelemetryButton>
        </div>
    );
};

const styles = stylex.create({
    blogLink: {
        marginBottom: 5,
    },
    blogSection: {
        gap: ComposableSpacing.s3,
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
    },
    latestBlogs: {
        gap: ComposableSpacing.s4,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
});

export default BlogSection;
